import { ContentCopy, Delete, Message } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const accent = "#3b82f6";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  return (
    <div
      style={{
        width: 210,
        backgroundColor: "#ffffff",
        borderRadius: 8,
        border: "1px solid #e5e7eb",
        boxShadow: "0 8px 18px rgba(15, 23, 42, 0.10)",
        overflow: "hidden"
      }}
    >
      <Handle
        type="target"
        position="left"
        style={{
          background: accent,
          width: 8,
          height: 8,
          left: -4,
          top: "50%"
        }}
        isConnectable={isConnectable}
      />

      <div
        style={{
          height: 34,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 10px 0 12px",
          background: "linear-gradient(180deg, rgba(59,130,246,0.08), rgba(59,130,246,0.02))",
          borderBottom: "1px solid rgba(59, 130, 246, 0.12)"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span
            style={{
              width: 21,
              height: 21,
              borderRadius: 5,
              background: "rgba(59, 130, 246, 0.12)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Message sx={{ width: 15, height: 15, color: accent }} />
          </span>
          <strong style={{ color: accent, fontSize: 13, fontWeight: 600 }}>Mensagem</strong>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ContentCopy
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
          <Delete
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
            sx={{ width: 15, height: 15, color: "#6b7280", cursor: "pointer" }}
          />
        </div>
      </div>

      <div
        style={{
          color: "#374151",
          fontSize: 12,
          lineHeight: 1.45,
          padding: "11px 14px",
          minHeight: 38,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word"
        }}
      >
        {data.label || "Mensagem"}
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: accent,
          width: 8,
          height: 8,
          right: -4,
          top: "50%"
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
